import { api } from '@/api'
import qs from 'qs'

interface GetEquipmentTaskRateListParams {
  perPage: number
  page: number
  q?: any
}

export default {
  get: ({ perPage, page, q }: GetEquipmentTaskRateListParams) => api.$get('/equipment_task_rates', {
    params: {
      page,
      per_page: perPage,
      q
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  getById: (id: number, params: any) => api.$get(`/equipment_task_rates/${id}`, {
    params,
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  patch: (id: number, include: string, params: any) => api.$patch(`/equipment_task_rates/${id}`, {
    EquipmentTaskRate: params,
    include,
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  })
}
